import { IMetadataProvider } from '@draeger-academy/common';


export class ContentPageMetadataProvider implements IMetadataProvider {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    private pageData: any;
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
    constructor(private _pageData: any) {
        this.pageData = _pageData;
    }

    public getTitle(): string {
        try {
            return this.transform(this.pageData.title);
        } catch (e) {
            return '';
        }
    }

    public getDescription(): string {
        try {
            return this.pageData._options.description;
        } catch (e) {
            return '';
        }
    }

    public getKeywords(): string {
        return '';
    }

    public getRobots(): string {
        try {
            return this._pageData._options.excludeFromSearch ? 'noindex' : 'index, follow';
        } catch (e) {
            return 'noindex';
        }
    }

    public getCanonicalUrl(): string {
        // const canonicalUrlPath = window && window.location ? window.location.pathname : '';
        // return `${this._appInfoService.AppInfo.server.origin}${canonicalUrlPath}`;
        return '';
    }

    public getImage(): string {
        try {
            return this.pageData._options.og.imageUrl.imageUrl;
        } catch (e) {
            return '';
        }
    }

    protected transform(value: string, ...args): string {
        return value.replace(/{(\d+)}/g, function(match, number) {
            return typeof args[number] !== 'undefined' ? args[number] : match;
        });
    }

    protected replace(value: string, searchStrings: string[], replaceStrings: string[] | string) {
        searchStrings.forEach((searchValue, index) => {
            const _replace = Array.isArray(replaceStrings) ? replaceStrings[index] : replaceStrings;
            value = value.replace(new RegExp(searchValue, 'g'), _replace);
        });
        return value;
    }
}
